import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useDocumentService } from '../../../../apis/documents/useDocumentService';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { TDocument } from '../../../../apis/documents/documents.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getStaffDocumentsKey = 'get-staff-documents';

export const useStaffDocumentsHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<TDocument[], TQueryError>
): UseQueryResult<TDocument[], TQueryError> => {
  const { getStaffDocuments } = useDocumentService();

  return useQuery<TDocument[], TQueryError>({
    queryKey: [getStaffDocumentsKey, params],
    queryFn: () => getStaffDocuments(params),
    enabled: true,
    ...options,
  });
};
